import Backbone from 'backbone';
import moment from 'moment';
import {PointScopeEnum, StartingTimescaleEnum} from 'common/proxies/enum-proxy';
import {getEnumBySlug, getEnumBySlugOrDefault} from 'common/utils/enum-util';
import {htmlUnescape} from 'common/utils/string-util';

export default Backbone.Model.extend({
  expandBaselines(baselines) {
    for (let ii = 0, nn = baselines.length; ii < nn; ii++) {
      const baseline = baselines[ii];
      baseline.firstReadingDate = moment(baseline.firstReadingDate);
      baseline.lastReadingDate = moment(baseline.lastReadingDate);
    }
    return baselines;
  },

  expandFacility(facility) {
    facility.displayName = htmlUnescape(facility.displayName);
    facility.points = this.getPoints(facility.points);
    return facility;
  },

  expandFacilities(results) {
    const facilities = [];
    for (let ii = 0, nn = results.length; ii < nn; ii++) {
      facilities.push(this.expandFacility(results[ii]));
    }
    return facilities;
  },

  getParsedTenants(tenants) {
    // Prepares Tenants, in place, treating its Spaces as points
    tenants.forEach((tenant) => {
      tenant.points = this.getPoints(tenant.points);
    });
    return tenants;
  },

  getPoints(points) {
    const appSlug = this.get('app').slug;
    return points.map((datum) => {
      const point = {
        ...datum,
      };

      // In trends, allow all enabled points
      // If there is a missing enumeration, provide a default for it
      if (appSlug === 'trends') {
        point.scope = getEnumBySlugOrDefault(point.scope, PointScopeEnum);
        point.startingTimescale = getEnumBySlugOrDefault(
          point.startingTimescale,
          StartingTimescaleEnum,
        );
      } else {
        point.scope = getEnumBySlug(point.scope, PointScopeEnum);
        point.startingTimescale = getEnumBySlug(
          point.startingTimescale,
          StartingTimescaleEnum,
        );
      }

      if (point.hasOwnProperty('baselines')) {
        point.baselines = this.expandBaselines(point.baselines);
      }

      return point.disabled ? null : point;
    });
  },

  parse(response) {
    this.set('app', window.settings.app);
    return {
      results: this.expandFacilities(response.buildings),
      tenants: this.getParsedTenants(response.tenants),
    };
  },
});
